module.exports = __webpack_public_path__ + "static/media/game_cover_capy@768.82422f85.png";